import React from "react";
import { NoDataPlaceholder } from "@/icons";
import "./NoDataState.css";

export default function NoDataState({ text = "No data available" }) {
    return (
        <div className="no-data-state">
            <div className="svg-wrap">
                <NoDataPlaceholder className="no-data-svg base" />
            </div>

            <div className="text">{text}</div>
        </div>
    );
}
